import { Timestamp } from "gen/google/protobuf/timestamp_pb"
import { CreditAllocationStatus } from "gen/txn/models_pb"
import { Format } from "shared-ts/classes/timestamp"
import { createColumnHelper } from "shared-web/components/composite/TableV2/createColumnHelper"
import { TableCellWidth } from "shared-web/components/composite/TableV2/TableCell"
import { Column } from "shared-web/components/composite/TableV2/useTable/types"

import { getTransactionDetails } from "features/pos/customers/ReceivablesHistoryPanel/ReceivablesHistoryPanel"

import { CreditReceivable } from "../../data/creditHistorySearch.adapter"

const colHelper = createColumnHelper<CreditReceivable>()

export function useCreditsTableColumns(): Column<CreditReceivable>[] {
  return [
    colHelper.id({
      accessorFn: ({ identifier }) => identifier,
      column: { title: "ID", width: TableCellWidth.ExtraLarge },
      chipColor: "yellow",
    }),
    colHelper.accessor(
      ({ receivableTxnType }) => getTransactionDetails(receivableTxnType).type,
      {
        title: "Type",
        width: TableCellWidth.Medium,
      }
    ),
    colHelper.timestamp(
      ({ date }) => Timestamp.fromDate(date),
      Format.DATE_SHORT,
      {
        title: "Date",
        width: TableCellWidth.Small,
      }
    ),
    colHelper.accessor(({ customer }) => customer?.name, {
      title: "Customer",
      width: TableCellWidth.ExtraLarge,
    }),
    colHelper.accessor(
      ({ status }) => {
        switch (status) {
          case CreditAllocationStatus.FULLY_ALLOCATED:
            return "Allocated"
          case CreditAllocationStatus.UNALLOCATED:
            return "Unallocated"
          case CreditAllocationStatus.PARTIALLY_ALLOCATED:
            return "Partially allocated"
          case CreditAllocationStatus.REFUNDED:
            return "Refunded"
          default:
            return "Unknown"
        }
      },
      {
        title: "Status",
        width: TableCellWidth.Large,
      }
    ),
    colHelper.money(({ balance }) => balance, {
      title: "Credit",
      width: TableCellWidth.Medium,
    }),
  ]
}
